<template>
    <div id="capacitaciones">
        <v-app>
            <el-row :gutter="20" type="flex" justify="center" align="middle">
                <el-col :span="18" class="titulo">
                    Historial de Capacitaciones
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" justify="center" align="middle">
                <el-col :span="22" class="cuerpo">

                    <!-- Alertas -->
                    <v-alert v-if="exito" type="success" color="green" :value="true">
                        La baja se ha realizado con éxito.
                    </v-alert>
                    <v-alert v-if="error" type="error" color="red" :value="true">
                        Ha ocurrido un error intentanto procesar su solicitud.<br>Por favor, intente nuevamente mas tarde.
                    </v-alert>
                    <br><br>

                    La <strong>capacitación docente</strong> o <strong>formación docente</strong> se refiere a las
                    políticas y procedimientos planeados para preparar a profesores dentro de los ámbitos del
                    <strong>conocimiento</strong>, <strong>actitudes</strong>, <strong>comportamientos</strong> y
                    <strong>habilidades</strong>, cada uno necesario para cumplir sus labores eficazmente en la sala
                    de clases y la comunidad escolar.-
                    <br><br><br>





                    <el-row>
                        <el-col :xs="24" :sm="12" style="background:#eee; border-radius:5px">
                            <v-text-field ref="Buscar" v-model="Search" append-icon="search" label="Buscar" single-line hide-details style="padding:10px"></v-text-field>
                        </el-col>
                    </el-row>
 

                               
                    <!-- Comisiones -->
                    <v-data-table :headers="Headers" :items="Comisiones" :search="Search" :pagination.sync="Pagination" style="margin-top:30px">
                       

                            <template slot="no-data" >
                                <el-col>
                                 <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>                                 
                               <el-col class="cargandomsg"> Cargando Datos </el-col>
                                </el-col>                               
                             </template>
                            
                               
                                                  
                        <template slot="items" slot-scope="props">
                            <td colspan="4" class="no_results_msj" v-if="props.item.resultado==0">
                                No se encontraron resultados
                            </td>
                            <tr v-else>                                
                                <td><router-link class="BtnA" :to="'comision/'+ props.item.Link +''">{{ props.item.idComision }}</router-link></td>
                                <td>
                                    <router-link class="BtnA" :to="'comision/'+ props.item.Link +''">{{ props.item.Nombre }}</router-link>
                                    &nbsp;&nbsp;<span v-if="props.item.mensajes" style="color:#f00" title="Mensajes sin Leer"><i class="el-icon-message"></i></span>
                                </td>
                                <td>{{ props.item.Certificado }}</td>
                                <td><center><strong>{{ props.item.Estado }}</strong></center></td>
                            </tr>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            No se encontraron resultados
                        </v-alert>
                    </v-data-table>

                    <!-- Bajas -->
                    <v-data-table :headers="Headers2" :items="Bajas" :search="Search" :pagination.sync="Pagination" style="margin-top:40px" class="TablaBaja">

                         <template slot="no-data" >
                                <el-col>
                                 <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>                                 
                                <el-col class="cargandomsg"> Cargando Datos </el-col>
                                </el-col>                               
                             </template>


                        <template slot="items" slot-scope="props">
                            <td colspan="3" class="no_results_msj" v-if="props.item.resultado==0">
                                No se encontraron resultados
                            </td>
                            <tr v-else>
                                <td><strong>{{ props.item.idComision }}     </strong></td>
                                <td><strong>{{ props.item.Capacitacion }}   </strong></td>
                                <td><center>{{ props.item.Fecha }}          </center></td>                                                            
                            </tr>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            No se encontraron resultados
                        </v-alert>
                    </v-data-table>
                </el-col>
            </el-row>
        </v-app>
    </div>
</template>



<script>
    import axios from 'axios';

    export default
    {   data()
        {   return {
                exito:      false,
                error:      false,
                Bajas:      [],
                Comisiones: [],
                idComision: '',
                idDCC:      '',
                Search:     '',
                cargamensaje: 0,
                Pagination: { 
                    descending: true,
                    rowsPerPage: 10,
                    sortBy: 'id' 
                },
                Headers: [{
                        text: 'Código ',
                        value: 'idComision'
                    },
                    {
                        text: 'Capacitación ',
                        value: 'Nombre'
                    },
                    {
                        text: 'Certificado ',
                        value: 'Certificado'
                    },
                    {
                        text: 'Estado ',
                        value: 'Estado'
                    }
                ],
                Headers2: [{
                        text: 'Comisión ',
                        value: 'idComision'
                    },
                    {
                        text: 'Bajas de Inscripciones ',
                        value: 'Capacitacion'
                    },
                    {
                        text: 'Fecha de Baja ',
                        value: 'Fecha'
                    }
                ],
            }
        },


        methods:
        {   SortIdComision: function(a,b)
            {   return parseInt(a.idComision) > parseInt(b.idComision);
            },
            SortEstado: function(a,b)
            {   return a.abiertacerrada < b.abiertacerrada;
            },
        },


        beforeMount()
        {   if(!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/cap.php', params, {headers: headers})
                    .then(response => {
                        const datos         = response.data
                        this.Bajas          = datos['Bajas'];
                        this.Comisiones     = datos['Comisiones'];
                       if(this.Comisiones==null)
                       {    
                        this.Comisiones     = [ {"resultado": 0}];                       
                       }
                       if(this.Bajas==null)
                       {    
                        this.Bajas     = [ {"resultado": 0}];                       
                       }                       
                       
                    })
                   /* .catch(e => {})*/
            }
        },


        mounted()
        {   this.$nextTick(this.$refs.Buscar.focus);
        }
    };
</script>


<style>
    .BtnA, .BtnA:visited
    {   color: #20A0FF;
        text-decoration: none;
        font-weight: bold;
        -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
    }
    .BtnA:hover, .BtnA:active, .BtnA:focus
    {   color: #788EDC;
        text-decoration: none;
        -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
    }

    .v-datatable thead tr th, .v-datatable thead tr td
    {   background: #00B5FF !important;
        text-align: center !important;
        color: #fff !important;
        font-weight: bold !important;
    }

    .TablaBaja .v-datatable thead tr th, .TablaBaja .v-datatable thead tr td 
    {   background: #FF9800 !important;
        text-align: center !important;
        color: #fff !important;
        font-weight: bold !important;
    }

    table tr:hover td
    {   background: #EEF1F6 !important;
    }
    .no_results_msj
    {
        text-align: center;
        width: 100%!important;         
        font-weight: 600!important;        
    }
    .cargandomsg
    {
            font-weight: 600!important;
            padding-bottom: 1%!important;

    }
</style>
